import { Page, Layout, LegacyCard, LegacyStack, Button, EmptyState } from '@shopify/polaris';
import { useContext, useEffect, useState } from 'react';
import { getProducts } from '../../../services/productService';
import ProductFilters from '../../UI/Products/ProductFilters';
import ProductsWrapper from '../../UI/Products/ProductsWrapper';
import ProductStockTable from '../../UI/Tables/ProductStockTable';
import { checkPermission } from '../../../services/permissionsService';
import ToastContext from '../../../context/ToastContext';
import { SET_ERROR } from '../../../context/ToastReducer';

const ViewProducts = () => {
  const [dataStock, setDataStock] = useState();
  const [filters, setFilters] = useState(null);
  const [, dispatchToast] = useContext(ToastContext);

  const callDB = (page = 1, limit = 10, rebuild = false) =>
    getProducts({ page, limit, ...filters })
      .then((r) => setDataStock({ ...r.data, new: rebuild }))
      .catch((e) =>
        dispatchToast({
          type: SET_ERROR,
          payload: { message: e.response?.data?.message || 'No se pudieron cargar los productos' },
        }),
      );

  useEffect(() => {
    if (filters) callDB(1, 10, true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters]);

  const isEmpty = dataStock && (dataStock.data?.length ?? 0) === 0;

  return (
    <>
      <Page
        title="Productos"
        divider
        primaryAction={
          <LegacyStack>
            {checkPermission('PRODUCT:CREATE') && (
              <Button url="/products/new" primary>
                Nuevo producto
              </Button>
            )}
            {checkPermission('PRODUCT:UPDATE') && <Button url="/files/products/eph/upc">Añadir fichero UPC EPH</Button>}
          </LegacyStack>
        }
      >
        <Layout>
          <Layout.Section>
            <LegacyCard>
              <LegacyCard.Section title="Filtros">
                <ProductFilters onFilterSelected={(filters) => setFilters(filters)} showStockFilter />
              </LegacyCard.Section>
            </LegacyCard>
          </Layout.Section>
          <Layout.Section>
            {isEmpty ? (
              <LegacyCard>
                <EmptyState
                  heading="Ningún producto coincide con los filtros"
                  image="https://cdn.shopify.com/s/files/1/0262/4071/2726/files/emptystate-files.png"
                >
                  <p>
                    Si acabas de dar de alta un producto, marca «Incluir productos sin stock»: el listado oculta por
                    defecto las familias sin mercancía.
                  </p>
                </EmptyState>
              </LegacyCard>
            ) : (
              dataStock && (
                <ProductsWrapper
                  data={dataStock}
                  TableComponent={(args) => <ProductStockTable {...args} />}
                  loadPage={(e) => callDB(e)}
                />
              )
            )}
          </Layout.Section>
        </Layout>
      </Page>
    </>
  );
};

export default ViewProducts;
